const lb = document.getElementById("lightbox");
const lbImg = document.getElementById("lb-img");
const lbCounter = document.getElementById("lb-counter");
const prevBtn = lb.querySelector(".lb-prev");
const nextBtn = lb.querySelector(".lb-next");

let photos = []; // [{thumb, full}]
let idx = 0;


// показать текущую фотку, подгрузить оригинал и соседей
function render() {
const p = photos[idx];
if (!p) return;

// 1) сразу показываем превью (быстро)
lbImg.style.opacity = "1";
lbImg.src = p.thumb;

// 2) параллельно грузим оригинал
const hi = new Image();
let canceled = false;

// если пользователь успел перелистнуть — отменим подмену
const myIdx = idx;

hi.onload = () => {
    if (canceled || idx !== myIdx) return;
    // плавная подмена на full
    lbImg.style.transition = "opacity .18s";
    lbImg.style.opacity = "0";
    requestAnimationFrame(() => {
    // маленькая задержка для плавности
    setTimeout(() => {
        lbImg.src = p.full;
        lbImg.onload = () => (lbImg.style.opacity = "1");
    }, 60);
    });
};

hi.onerror = () => {
    // full не загрузился — остаёмся на превью
    // можно логнуть при желании
};

hi.src = p.full;

// предзагрузка соседей (оригиналы), без DOM
[idx - 1, idx + 1].forEach(j => {
    if (j >= 0 && j < photos.length) {
    const im = new Image();
    im.src = photos[j].full;
    }
});

lbCounter.textContent = `${idx + 1} / ${photos.length}`;

// если во время загрузки пользователь листнул — отменяем замену
render.cancel = () => { canceled = true; };
}

// открыть лайтбокс и загрузить фотосет
async function openLB(nom, feat, startThumb, folder) {
try {
    const u = new URL("/api/photoset", location.origin);
    u.searchParams.set("folder", folder);
    u.searchParams.set("nom", nom);
    u.searchParams.set("feat", feat);
    const res = await fetch(u, { cache: "no-store" });
    photos = await res.json();
    if (!Array.isArray(photos) || photos.length === 0) return;

    // стартовый индекс — по текущему превью, если нашли
    const startIdx = photos.findIndex(p => p.thumb === startThumb);
    idx = startIdx >= 0 ? startIdx : 0;

    lb.classList.add("is-open");
    document.body.style.overflow = "hidden";
    render();
} catch (e) {
    console.error("photoset fetch failed", e);
}
}

function closeLB() {
lb.classList.remove("is-open");
document.body.style.overflow = "";
lbImg.removeAttribute("src"); // даём GC освободить память
photos = []; idx = 0;
}

function go(dir) {
if (!photos.length) return;
if (typeof render.cancel === "function") render.cancel();
idx = (idx + dir + photos.length) % photos.length;
render();
}

// события lightbox
lb.addEventListener("click", (e) => {
if (e.target.hasAttribute("data-lb-close")) closeLB();
});
lb.querySelectorAll("[data-lb-close]").forEach(el => el.addEventListener("click", closeLB));
prevBtn.addEventListener("click", () => go(-1));
nextBtn.addEventListener("click", () => go(1));
document.addEventListener("keydown", (e) => {
if (!lb.classList.contains("is-open")) return;
if (e.key === "Escape") closeLB();
if (e.key === "ArrowLeft") go(-1);
if (e.key === "ArrowRight") go(1);
});

// ОТКРЫТИЕ: по одному клику (можно заменить на dblclick)
document.body.addEventListener("click", (e) => {
const img = e.target.closest(".clickable-photo");
if (!img) return;
// данные для запроса
const nom   = img.dataset.nom   || "";
const feat  = img.dataset.feat  || "";
const folder = img.dataset.folder || "";
const start = img.getAttribute("src") || "";
openLB(nom, feat, start, folder);
});